<div class="row">
    <div class="col-4">
        <!--begin::Row-->
        <div class="row g-5 g-lg-10">
            <!--begin::Card-->
            <div class="col-xxl-6 col-md-3 mb-xxl-10">
                <!--begin::Widget-->
                <div class="card h-100 card-flush shadow-sm cursor-pointer card-hover-active" (click)="navigateTo('contracts')">
                    <div class="card-header mt-4">
                        <div class="align-self-center">
                            <i class="fa-duotone fa-solid fa-file-contract fa-3x navigation-card-icon"></i>
                        </div>
                    </div>
                    <div class="card-body h-100 d-flex py-5">
                        <span class="align-self-end">
                            <h4 style="vertical-align: middle;" class="d-inline-block">
                                {{ 'CONTRACTS' | translate }}
                            </h4>
                        </span>
                    </div>
                </div>
                <!--end::Widget-->
            </div>
            <!--end::Card-->

            <!--begin::Card-->
            <div class="col-xxl-6 col-md-3 mb-xxl-10">
                <!--begin::Widget-->
                <div class="card h-100 card-flush shadow-sm card-hover-active" (click)="navigateTo('tickets/messages')">
                    <div class="card-header mt-4">
                        <div class="align-self-center">
                            <i class="fa-duotone fa-solid fa-circle-info fa-3x navigation-card-icon"></i>
                        </div>
                    </div>
                    <div class="card-body d-flex py-5 pe-20" style="white-space: nowrap;">
                        <span class="align-self-end">
                            <h4>
                                {{ 'REQUESTS' | translate }} <wbr/> {{ 'SUPPORT_REQUESTS_CONT' | translate }}
                            </h4>
                        </span>
                    </div>
                </div>
                <!--end::Widget-->
            </div>
            <!--end::Card-->
        </div>
        <!--end::Row-->
        <!--begin::Row-->
        <div class="row g-5 g-lg-10">

            <!--begin::Card-->
            <div class="col-xxl-6 col-md-3 mb-xxl-10">
                <div class="card h-100 card-flush shadow-sm card-hover-active" (click)="navigateTo('market-dealers/dashboard')">
                    <div class="card-header mt-4">
                        <div class="align-self-center">
                            <i class="fa-duotone fa-solid fa-magnifying-glass-waveform fa-3x navigation-card-icon"></i>
                        </div>
                    </div>
                    <div class="card-body d-flex py-5 pe-20">
                        <span class="align-self-end">
                            <h4>
                                {{ 'DAILY_MARKET' | translate }}
                            </h4>
                        </span>
                    </div>
                </div>
            </div>
            <!--end::Card-->

            <!--begin::Card-->
            <div class="col-xxl-6 col-md-3 mb-xxl-10">
                <div class="card h-100 card-flush shadow-sm card-hover-active" (click)="navigateTo('proposals')">
                    <div class="card-header mt-4">
                        <div class="align-self-center">
                            <i class="fa-duotone fa-solid fa-file-invoice fa-3x navigation-card-icon"></i>
                        </div>
                    </div>
                    <div class="card-body d-flex py-5">
                        <span class="align-self-end">
                            <h4>
                                {{ 'PROPOSALS' | translate }}
                            </h4>
                        </span>

                    </div>
                </div>
            </div>
            <!--end::Card-->

        </div>

        <div class="row g-5 g-lg-10">
            <!--begin::Card-->
            <div class="col-xxl-12 col-md-3 mb-xxl-10">
                <div class="card h-100 card-flush shadow-sm notification-box">
                    <div class="card-header">
                        <div class="card-title">
                            <strong style="font-size: 17px;">{{ 'NOTIFICATIONS' | translate }}</strong>
                        </div>
                    </div>
                    <div #notificationPanel class="card-body pb-0 pt-5 pe-5 notification-panel">
                        <div class="row mb-5 notification py-1" *ngFor="let alert of userAlerts">
                            <div class="col-1 align-content-center">
                                <i class="fa-duotone fa-solid fa-circle-info fa-2x"
                                    style="--fa-primary-color: #008445;--fa-secondary-color: #008445"></i>
                            </div>
                            <div class="col-11 ps-6">
                                <span class="align-self-start fs-5" style="white-space: nowrap;">
                                    <strong>{{ 'SUPPORT_REQUEST' | translate }}</strong>
                                    <span class="ms-2 fs-7 pe-2 ps-1 fw-bold"
                                        style="border-radius: 5px; background-color: #A7CDB5;">
                                        {{ alert.creationDate | date : 'dd/MM/YYYY' }} - {{ 'DATE_DIFF' | translate : {
                                        difference: alert.dateDiff } }} {{ alert.dateDiffMetric | translate }}
                                    </span>
                                </span><br>
                                <span class="align-self-end fs-5" style="color: #959493">{{ alert.body }}</span>
                            </div>
                        </div>

                        <ng-container *ngIf="_isLoadingFlag">
                            <div class="row mb-5">
                                <div class="col-1 align-content-center">
                                    <i class="fa-duotone fa-solid fa-circle-info fa-2x"
                                        style="--fa-primary-color: #008445;--fa-secondary-color: #008445"></i>
                                </div>
                                <div class="col-11 ps-6">
                                    <span class="align-self-start fs-5" style="white-space: nowrap;">
                                        <strong>{{ 'SUPPORT_REQUEST' | translate }}</strong>
                                        <span class="ms-2 fs-7 pe-2 ps-1 fw-bold"
                                            style="border-radius: 5px; background-color: #A7CDB5;">

                                        </span>
                                    </span><br>
                                    <span class="align-self-end fs-5" style="color: #959493"></span>
                                </div>
                            </div>
                        </ng-container>

                    </div>
                </div>
            </div>
            <!--end::Card-->

        </div>
    </div>
    <div class="col-8 ps-7">

        <div class="row">
            <!--begin::Card-->
            <div class="mb-xxl-10 col-12">
                <!--begin::Widget-->
                <div class="card h-100 card-flush shadow-sm bg-primary greeting-banner">
                    <div class="card-body py-8 h-100 d-flex justify-content-between py-2">
                        <span class="align-self-center my-10 text-white" style="font-size: 48px; line-height: normal;">
                            {{ 'HELLO' | translate }},<br>
                            <strong>{{ user?.firstName + ' ' + user?.lastName }}</strong>
                        </span>
                    </div>
                </div>
                <!--end::Widget-->
            </div>
            <!--end::Card-->
            <!--begin::Card-->
            <div class="col-xxl-6 col-md-3 mb-xxl-10 pe-5">
                <!--begin::Widget-->
                <div class="card h-100 card-flush shadow-sm">
                    <div class="card-header p-5 ps-10">
                        <span style="font-size: 17px;">
                            <strong>{{ 'DAILY_MARKET' | translate }} | {{ 'ELECTRICITY' | translate }}</strong>
                            <br>
                            {{ 'MEDIAN_PRICE_PT' | translate }}
                        </span>
                    </div>
                    <div class="card-body h-100 d-flex justify-content-center py-3">
                        <div class="border rounded-circle d-flex justify-content-center"
                            style="width: 130px;height: 130px; border-color: #B0DC00 !important;">
                            <div class="align-content-center text-center">
                                <i class="fa-3x fa-solid fa-bolt" style="color:#B0DC00"></i><br>
                                <span>
                                    <h2 class="m-0 mt-1">{{ averageElectricityQuantity | number : '' : 'pt-PT' }}</h2>
                                    €/MWh
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::Widget-->
            </div>
            <!--end::Card-->
            <!--begin::Card-->
            <div class="col-xxl-6 col-md-3 mb-xxl-10 ps-5">
                <!--begin::Widget-->
                <div class="card h-100 card-flush shadow-sm">
                    <div class="card-header p-5 ps-10">
                        <span style="font-size: 17px;">
                            <strong>{{ 'DAILY_MARKET' | translate }} | {{ 'NATURAL_GAS' | translate }}</strong>
                            <br>
                            {{ 'MEDIAN_PRICE_PT' | translate }}
                        </span>
                    </div>
                    <div class="card-body h-100 d-flex justify-content-center py-3">
                        <div class="border rounded-circle d-flex justify-content-center"
                            style="width: 130px;height: 130px; border-color: #4FC9DA !important;">
                            <div class="align-content-center text-center">
                                <i class="fa-3x fa-solid fa-fire" style="color:#4FC9DA"></i><br>
                                <span>
                                    <h2 class="m-0 mt-1">
                                        <!--{{ averageGasQuantity | number : '' : 'pt-PT' }}-->
                                        -
                                    </h2>
                                    €/MWh
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::Widget-->
            </div>
            <!--end::Card-->

            <div class="col-xxl-12 col-md-3 mb-xxl-10 ps-5" *ngIf="chartOptions">
                <div class="card h-100 card-flush shadow-sm">
                    <div class="card-header p-5 ps-10 ">
                        <h3 class="card-title" style="font-size: 17px;">
                            <div class="d-flex flex-column">
                                <strong>{{ 'DAILY_MARKET_PRICE' | translate }}</strong>
                                <ng-container class="" *ngIf="user?.countryCode == 'PT'"> {{'PORTUGAL' | translate}}</ng-container>
                                <ng-container class="" *ngIf="user?.countryCode == 'ES'"> {{'SPAIN' | translate}}</ng-container>
                            </div>
                        </h3>

                        <div class="card-toolbar">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <span class="me-2 text-gray-700">
                                    {{ selectedDate | date: 'dd/MM/yyyy' }}
                                </span>

                                <button class="btn btn-sm btn-icon btn-light" (click)="picker.open()">
                                    <i class="fas fa-calendar"></i>
                                </button>

                                <div style="position: absolute; opacity: 0; pointer-events: none; height: 0;">
                                        <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate"
                                            [min]="minDate" [max]="maxDate" (ngModelChange)="onSelectedDateChange()" />
                                        <mat-datepicker #picker></mat-datepicker>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="card-body">
                        <is-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis"
                            [plotOptions]="chartOptions.plotOptions" [dataLabels]="chartOptions.dataLabels"
                            [tooltip]="chartOptions.tooltip"
                            [colors]="chartOptions.colors"></is-chart>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>